module.exports = "/_next/static/images/mycelium-f9d8a1600a8984093873acda1df6e8b9.png";